/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Preview_Failed1Inputs */

const vi_cmstools_preview_failed1 = /** @type {(inputs: Cmstools_Preview_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tạo được link xem trước. Kiểm tra mạng rồi thử lại.`)
};

/**

* @param {Cmstools_Preview_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_preview_failed1 = /** @type {((inputs?: Cmstools_Preview_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Preview_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_preview_failed1(inputs)
});
export { cmstools_preview_failed1 as "cmsTools_preview_failed" }